module.exports = __webpack_public_path__ + "static/design-bbf70f2f7987653d77c697a238a8000d.png";